import React from 'react'
import style from './expandableEntity.module.css'

const ExpandableEntity = ({ children }) => {
    return <div className={style.root}>{children}</div>
}

export default ExpandableEntity
